const digitalFormsBaseUrl = `DigitalForms`;

export const getTAFFunds = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/TAFFunds/${assistanceProgramId}`);
}

export const getTAFFundMedications = async (axiosGet, assistanceProgramId) => {
    return await axiosGet(`${digitalFormsBaseUrl}/FoundationFundMedications/${assistanceProgramId}`);
}

const TAFLivingInUSSpecialRule = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Patient Citizen', value, 'Patient must be a U.S. citizen in order to be eligible for enrollment.');
    }
}


const TAFFundRequiresInsuranceSpecialRule = (value, ctx) => {
    const insuranceField = 'Insurance Does Patient Have Insurance';
    const field = ctx.getFieldDef(insuranceField);

    if (field && value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData(insuranceField, value, 'Patient must have insurance for requested therapy to apply.');
    }
}

const TAFEmptyFundIfInsuranceChangesSpecialRule = (value, ctx) => {
    const primaryInsuranceField = 'Insurance Patient Insurance Types TAF';
    const field = ctx.getFieldDef(primaryInsuranceField);
    if (field) {
        ctx.specialRuleChangeData('TAF Fund Selection', undefined);
    }
}

export const TAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule = (value, ctx) => {
    if (!value) return;

    const invalidCharsReg = /[^a-zA-Z\- ]/gm;
    const hasInvalidCharacters = value.match(invalidCharsReg) || value[0] === " " || value[0] === "-";

    if (hasInvalidCharacters) {
        const fieldIndex = Object.values(ctx.formData).indexOf(value);
        const fieldName = Object.keys(ctx.formData)[fieldIndex];
        ctx.specialRuleChangeData(fieldName, value, 'Please remove numbers and/or special characters as they are not acceptable in the provider portal.');
    }
}

export const TAFSecondaryPhoneTypeSpecialRule = (value, ctx) => {
    //primary will have all 3 but secondary can only have the 2 leftover options
    //options are mobile, work and home
    //need to also empty secondary field if primary field type is updated to same value
    const primaryPhoneTypeField = 'Primary Phone Type';
    const field = ctx.getFieldDef(primaryPhoneTypeField);

    if (field && value) {
        const secondaryPhoneTypeField = "Secondary Phone Type";
        let secondaryTypes = [];
        if (value.toLowerCase() === "mobile") {
            secondaryTypes = ["Home", "Work"];
        }
        else if (value.toLowerCase() === "home") {
            secondaryTypes = ["Mobile", "Work"];
        }
        else {
            secondaryTypes = ["Mobile", "Home"];
        }
        const secondaryField = ctx.getFieldDef(secondaryPhoneTypeField);
        secondaryField.options = secondaryTypes;
        secondaryField.values = secondaryTypes;

        //empty secondary field if primary field type is updated to same value
        if (field.value === secondaryField.value) {
            ctx.formData[secondaryPhoneTypeField] = null;
        }

    }
    //check if Contact Via Text/Preferred Contact Method question needs to be updated
    TAFPreferredContactIsText(value, ctx);
}

export const TAFPreferredContactIsText = (value, ctx) => {
    const perferredField = 'Preferred Contact Method';
    let fieldValue = ctx.formData[perferredField]
    if (fieldValue?.toLowerCase() === 'text') {
        //if primary and secondary types are not mobile, trigger message
        let primaryIsMobile = ctx.formData['Primary Phone Type'] === 'Mobile';
        let secondaryIsMobile = ctx.formData['Secondary Phone Type'] === 'Mobile';
        if (!primaryIsMobile && !secondaryIsMobile) {
            ctx.specialRuleChangeData(perferredField, fieldValue, 'You must supply a Mobile number in order for preferred contact method to be Text.');
        }
        else {
            ctx.specialRuleChangeData(perferredField, fieldValue);
        }

    }
}

export const TAFGeneticTesting = (value, ctx) => {
    if (value?.toLowerCase() === 'no') {
        ctx.specialRuleChangeData('Genetic Testing for Disease', value, 'Patient must be diagnosed with the disease state(s) covered by the program or in the process of completing genetic testing for the disease state(s) for which they are applying.');
    }
}

export const TAFSecondaryPhoneTypeRules = (value, ctx) => {
    TAFPreferredContactIsText(value, ctx);
}

export const createTAFRules = (meta, ctx) => {

    ctx.createSpecialRule('Patient Citizen', TAFLivingInUSSpecialRule);
    ctx.createSpecialRule('Insurance Does Patient Have Insurance', TAFFundRequiresInsuranceSpecialRule);
    ctx.createSpecialRule('Insurance Patient Insurance Types TAF', TAFEmptyFundIfInsuranceChangesSpecialRule);
    ctx.createSpecialRule('Primary Phone Type', TAFSecondaryPhoneTypeSpecialRule);
    ctx.createSpecialRule('Secondary Phone Type', TAFSecondaryPhoneTypeRules);
    ctx.createSpecialRule('Genetic Testing for Disease', TAFGeneticTesting);
    ctx.createSpecialRule('Preferred Contact Method', TAFPreferredContactIsText);

    // Run all the special rules to make sure a loaded draft loads with any necessary errors
    TAFFundRequiresInsuranceSpecialRule(ctx.formData['Insurance Does Patient Have Insurance'], ctx);
    TAFLivingInUSSpecialRule(ctx.formData['Patient Citizen'], ctx);
    TAFSecondaryPhoneTypeSpecialRule(ctx.formData['Primary Phone Type'], ctx)
    TAFGeneticTesting(ctx.formData['Genetic Testing for Disease'], ctx);
    TAFPreferredContactIsText(ctx.formData['Preferred Contact Method'], ctx);
    TAFSecondaryPhoneTypeRules(ctx.formData['Secondary Phone Type'], ctx);

    const alphabeticSpacesHyphensOnlyFields = ['Patient Name First', 'Patient Name Last'];
    alphabeticSpacesHyphensOnlyFields.forEach(field => {
        ctx.createSpecialRule(field, TAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule);
        TAFOnlyAlphabeticCharsSpacesHyphensAllowedSpecialRule(ctx.formData[field], ctx);
    });
}
